
import axios from "axios";
import { DURATION_LABEL_KEYS as DLK } from "../constants/layout";
import { BUNDLE_CART_ITEM_TYPENAME, BUNDLE_TYPENAME, CONFIGURABLE_TYPENAME, DURATION_MATCHING, DURATION_SPAN_YEARLY_ZUORA, TERMED_ATTRIBUTE_SETS, TIPO_RINNOVO_AUTOMATICO, TIPO_RINNOVO_ESPLICITO, ZUORA_BILLING_SPANS_MAP } from "../constants/product";
import { DEFAULT_STORE_CODE } from "../constants/store";
import { DELIVERY_TYPES_MAP, DELIVERY_TYPES_OPTION_MAP, NO_CONSEGNA_DELIVERY_TYPE } from "./functions";
import Item from "~/components/solepro/MiniCart/Item.vue";

const DURATION_LABEL_KEYS = Object.assign(DLK)
export const composeBundleInfos = (product, tipo_value_index, consegna_value_index, modulesSkus) => {
  let datas = [];
  product.items.forEach(bundleOption => {
    bundleOption.options.forEach(option => {
      if (consegna_value_index) {
        const tipoConsegnaConfigOption = option.product.configurable_options ? option.product.configurable_options.find(el => el.attribute_code == 'tipo_consegna') : null;
        //console.log(tipoConsegnaConfigOption.values.map(el=>el.value_index))
        if (tipoConsegnaConfigOption) {
          let variants = {}
          let configOptions = {}
          variants[bundleOption.option_id] = { selection_id: option.id, ...option.product.variants.find(variant => (!tipo_value_index || variant.product.tipo_abbonamento == tipo_value_index) && variant.product.tipo_consegna == consegna_value_index) };
          configOptions[bundleOption.option_id] = tipoConsegnaConfigOption;
          datas.push({
            option_id: bundleOption.option_id,
            selectedOptionIds: [option.id],
            variants,
            configOptions
          })
        }
      }
      if (tipo_value_index) {
        const tipoAbbonamentoConfigOption = option.product.configurable_options ? option.product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento') : null;
        if (tipoAbbonamentoConfigOption) {
          let variants = {};
          let configOptions = {};
          configOptions[bundleOption.option_id] = tipoAbbonamentoConfigOption;
          variants[bundleOption.option_id] = { selection_id: option.id, ...option.product.variants.find(variant => variant.product.tipo_abbonamento == tipo_value_index) };
          datas.push({
            option_id: bundleOption.option_id,
            selectedOptionIds: [option.id],
            variants,
            configOptions
          })
        }
      }
    })
    /** Getting options for choosen modules */
    if (modulesSkus && modulesSkus.length > 0) {
      const modulesUids = bundleOption.options.filter(el => modulesSkus.includes(el.product.sku)).map(el => el.id);
      if (modulesUids.length > 0) {
        datas.push({
          option_id: bundleOption.option_id,
          selectedOptionIds: modulesUids
        })
      }
    }
  })

  return datas;
}

export const composeQueryString = (queryStringAsObj: { [key: string]: string }): string => Object.keys(harvestQueryString(queryStringAsObj)).length !== 0 ? `&${new URLSearchParams(harvestQueryString(queryStringAsObj)).toString()}` : "";

const harvestQueryString = (queryStringAsObj: { [key: string]: string }) => {
  /** @NOTE Avoid unwanted params to be transported inside the checkout. */
  const queryParams = { ...queryStringAsObj }

  /** Array of properties to delete */
  const harvestPropertiesMap = [
    'sku',
    'moduli',
    'tipoAbbonamento',
    'tipoConsegna'
  ];
  harvestPropertiesMap.forEach(property => delete queryParams[property]);
  return queryParams;
}


export const getSecondLine = (i18n, cartItem, p, variantSku, paymentFrequency = null) => {
  const variant = variantSku ? p.variants.find(el => el.product.sku == variantSku) : null;
  let labels = [];
  if (variant && !!variant.product.natura) {
    if (p.configurable_options.find(el => el.attribute_code == 'natura')) labels = [{
      title: 'Formato',
      content: i18n.t(p.configurable_options.find(el => el.attribute_code == 'natura').values.find(el => el.value_index == variant.product.natura).label.replace('Formato ', ''))
    }]
  } else if (cartItem.bundle_options && cartItem.bundle_options.length > 0) {
    const mods = cartItem.bundle_options.map((opt, index) => opt.values.map(e => e.label).join('; '))
    labels = [{
      title: `Prodotti inclusi(${mods.length})`,
      content: mods.join('; ')
    }]
  } else if (variant) {
    labels = [{
      content: variant.product.name.replace(cartItem.product.name + ' - ', '').replace(cartItem.product.name, '')//rimozione stilistica della ripetizione del prodotto principale
    }]
  }
  if (paymentFrequency) {
    labels.push({
      title: 'Periodicità pagamento',
      content: i18n.t(`payment_frequency_${DURATION_MATCHING[paymentFrequency]}`)
    })
    if (variant) {
      labels = labels.filter(el => el.title || (!el.title && el.content.toLowerCase().trim() !== i18n.t(`payment_frequency_${DURATION_MATCHING[paymentFrequency]}`).toLowerCase().trim()))
    }
  }
  return labels;
}

const getDiscountedLabel = (product, i18n, $fc, discountDatas) => {
  if (discountDatas.percentage) {
    return (i18n.t("{price} {percentage} {discountedPrice}", {
      price: $fc(discountDatas.amountWithoutPromo),
      discountedPrice: $fc(discountDatas.amount),
      percentage: discountDatas.percentage
    }) as String)
  } else if (product.price_range.maximum_price.final_price.value < product.price_range.maximum_price.regular_price.value) {
    const percentage = 100 - Math.floor(100 * product.price_range.maximum_price.final_price.value / product.price_range.maximum_price.regular_price.value)
    return (i18n.t("{price} {percentage} {discountedPrice}", {
      price: $fc(product.price_range.maximum_price.regular_price.value),
      discountedPrice: $fc(product.price_range.maximum_price.final_price.value),
      percentage
    }) as String)
  } else {
    return $fc(product.price_range.maximum_price.final_price.value)
  }
}

const getNormalPrice = (product, i18n, $fc, variant, span, discountDatas) => {
  if (span) {
    if (discountDatas.percentage && product.prices[span] > 0) {
      return (i18n.t("{price} {discountedPrice} / {durationQty} {duration}", {
        price: $fc(discountDatas.amountWithoutPromo),
        discountedPrice: $fc(discountDatas.amount),
        duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
        durationQty: 1,
      }) as String) + i18n.t("red {percentage}%", { percentage: discountDatas.percentage })
    } else {
      return $fc(variant ? getDiscountedLabel(variant, i18n, $fc, discountDatas) : '--')
    }
  } else if (variant) {
    return getDiscountedLabel(variant, i18n, $fc, discountDatas)
  } else if (product.prices && Object.keys(product.prices).length > 0) {
    return discountDatas.percentage ? (i18n.t("{price} {percentage} {discountedPrice}", 1, {
      price: $fc(discountDatas.amountWithoutPromo),
      discountedPrice: $fc(discountDatas.amount)
    }) as String) + i18n.t("red {percentage}%", { percentage: discountDatas.percentage })
      : $fc(product.prices[Object.keys(product.prices)[0]])
  }
}

const getPriceByConfig = (labels, index, i18n, $fc, product, span, variant, discountDatas) => {
  if (product.promotional[span]) {
    labels[index] = (product.promotional[span].price < product.prices[span]) ?
      i18n.tc(`cart ${index == 0 ? 'first ' : ''}{durationQty} {duration} at {price} {discountedPrice}`, product.promotional[span].duration, {
        duration: i18n.tc(DURATION_LABEL_KEYS[span], product.promotional[span].duration),
        durationQty: product.promotional[span].duration,
        price: $fc(product.prices[span]),
        discountedPrice: discountDatas.percentage
          ? i18n.t("{price} {percentage} {discountedPrice}", { price: $fc(discountDatas.amountWithoutPromo), discountedPrice: $fc(discountDatas.amount), percentage: discountDatas.percentage })
          : $fc(product.promotional[span].price)
      })
      : i18n.tc(`cart ${index == 0 ? 'first ' : ''}{durationQty} {duration} at {discountedPrice}`, product.promotional[span].duration, {
        duration: i18n.tc(DURATION_LABEL_KEYS[span], product.promotional[span].duration),
        durationQty: product.promotional[span].duration,
        discountedPrice: $fc(product.promotional[span].price)
      })

    labels[index + 1] = i18n.tc(`${index == 0 ? 'first ' : ''}cart {price} / each {durationQty} {duration}`, 1, {
      price: $fc(product.discountedPrices[span] ? product.discountedPrices[span] : product.prices[span]),
      durationQty: 1,
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
    })

  } else if (product.discountedPrices[span]) {
    let price = $fc(product.prices[span])
    let discountedPrice = $fc(product.discountedPrices[span])
    let discount = ''
    if (discountDatas.percentage) {
      price = $fc(discountDatas.amountWithoutPromo)
      discountedPrice = $fc(discountDatas.amount)
      discount = i18n.t('red {percentage}%', { percentage: discountDatas.percentage })
      labels[index] = (i18n.tc(`${index == 0 ? '' : 'then '}{price} {discountedPrice} / {durationQty} {duration}`, 1, {
        price,
        discountedPrice,
        durationQty: 1,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
      }) as String) + discount
    } else {
      labels[index] = i18n.tc(`recurring cart ${index == 0 ? 'first ' : ''}{durationQty} {duration} at {price} {discountedPrice}`, 1, {
        price: $fc(product.prices[span]),
        discountedPrice: $fc(product.discountedPrices[span]),
        durationQty: 1,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
      })
    }
  } else if(product.prices[span]){
    labels[index] = span ? i18n.tc(`${index == 0 ? 'first ' : ''}cart {price} / each {durationQty} {duration}`, 1, {
      price: $fc(product.prices[span] > 0 ? product.prices[span] : (variant ? variant.price_range.maximum_price.final_price.value : '--')),
      durationQty: 1,
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String
      : getNormalPrice(product, i18n, $fc, variant, span, discountDatas)

  } else {
    labels[index] = i18n.t(`${index == 0 ? 'first ' : ''}cart {price}`, {
      price: $fc(product.full_price &&  product.full_price > 0 ? product.full_price : (variant && variant.full_price ? variant.full_price : variant?.price_range?.maximum_price?.final_price?.value ?? '--')),
    
    })
  }
  return labels
}
/**
 * @TODO Questa logica è orrenda, lo so, la fretta ci rende tutti un po' come dott.Frankenstein.
 * La devo rifare assolutamente da capo.
 */
export const getLabels = (i18n, $fc, discountDatas, product, span, variantSku) => {
  let labels = []
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan) || product.forceShowTrialInEachPriceSection);
  if (isCurrentPlanTrial) {
    labels[0] = i18n.tc('{durationQty} {duration} of trial at {trialPrice}', product.trialPrice, {
      durationQty: product.trialDuration,
      duration: i18n.tc(DURATION_LABEL_KEYS[product.trialDurationSpan], product.trialDuration),
      trialPrice: $fc(product.trialPrice)
    }) as String
  }

  /** setting firstIndex as 1 if the product is trial (has label 0 already populated) */
  let index = !!labels[0] ? 1 : 0;

  if (variantSku && product.variants) {
    const v = product.variants.find(el => el.product.sku == variantSku).product;

    if (v.startup_cost && v.startup_cost > 0) {
      const fullPrice = v.full_price ? v.full_price : v.price_range.maximum_price.final_price.value
      if (isCurrentPlanTrial) {
        labels[1] = i18n.t("cart {startupCost}", { startupCost: $fc(v.startup_cost) })
        labels[2] = i18n.tc("cart {price} / each {durationQty} {duration}", 1, {
          price: $fc(v.discounted_price && v.discounted_price < fullPrice ? v.discounted_price : fullPrice),
          durationQty: 1,
          duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
        }) as String
      } else {
        labels[0] = i18n.tc("{durationQty} {duration} at {price}", 1, {
          price: $fc(v.promotional_price ?? (v.discounted_price ?? fullPrice)),
          durationQty: 1,
          duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
        }) as String
        labels[1] = i18n.t("cart {startupCost}", { startupCost: $fc(v.startup_cost) })
        labels[2] = i18n.tc("cart {price} / each {durationQty} {duration}", 1, {
          price: $fc(v.discounted_price && v.discounted_price < fullPrice ? v.discounted_price : fullPrice),
          durationQty: 1,
          duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
        }) as String
      }
    } else {

      if (discountDatas.percentage && discountDatas.amount && discountDatas.amountWithoutPromo) {
        labels[index] = (i18n.t("{price} {percentage} {discountedPrice}", {
          price: $fc(discountDatas.amountWithoutPromo),
          discountedPrice: $fc(discountDatas.amount),
          percentage: discountDatas.percentage
        }) as String)
      } else if (v.price_range.maximum_price.final_price.value < v.price_range.maximum_price.regular_price.value) {
        labels[index] = getDiscountedLabel(v, i18n, $fc, discountDatas)

      } else { labels = getPriceByConfig(labels, index, i18n, $fc, product, span, v, discountDatas) }
    }
  } else {
    if (product.startupCost && product.startupCost > 0) {
      if (isCurrentPlanTrial) {
        labels[1] = i18n.t("cart {startupCost}", { startupCost: $fc(product.startupCost) })
        labels[2] = i18n.tc("cart {price} / each {durationQty} {duration}", 1, {
          price: $fc(product.discountedPrices[span] && product.discountedPrices[span] < product.prices[span] ? product.discountedPrices[span] : product.prices[span]),
          durationQty: 1,
          duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
        }) as String
      } else {
        labels[0] = i18n.tc("{durationQty} {duration} at {price}", 1, {
          price: $fc(product.promotional[span].price ?? (product.discountedPrices[span] ?? product.prices[span])),
          durationQty: 1,
          duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
        }) as String
        labels[1] = i18n.t("cart {startupCost}", { startupCost: $fc(product.startupCost) })
        labels[2] = i18n.tc("cart {price} / each {durationQty} {duration}", 1, {
          price: $fc(product.discountedPrices[span] && product.discountedPrices[span] < product.prices[span] ? product.discountedPrices[span] : product.prices[span]),
          durationQty: 1,
          duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
        }) as String

      }
    } else { labels = getPriceByConfig(labels, index, i18n, $fc, product, span, null, discountDatas) }
  }



  return labels
}

export const getZuoraLabels = (i18n, $fc, discountDatas, zuoraItemDataPlan, product, span, variantSku) => {
  const discount = discountDatas.discountType == 'percent' ? i18n.t("red {percentage}%", { percentage: parseFloat(discountDatas.percentage) }) : i18n.t('red {value}', { value: discountDatas.discountAmount })
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan) || product.forceShowTrialInEachPriceSection);
  const labels = [];
  
  const everlastingPlan = zuoraItemDataPlan.find(el => el.planType == 'Everlasting')
  const currentPlans = zuoraItemDataPlan.filter(el => el.planType == 'Current')
  /** Current payment management */
  /** TRIAL MANAGEMENT */
  const currentPlan = currentPlans[0]
  if (currentPlan && isCurrentPlanTrial) {
    let durationQtyMatch = currentPlan.billingPeriod.match(/\d+/g)
    durationQtyMatch = durationQtyMatch ? durationQtyMatch[0] : 1;
    const durationMatch = currentPlan.billingPeriod.match(/[^\d]+/g)[0]
    const trialPriceAmount = parseFloat(currentPlan.amount.toFixed(2))
    if (product.trialPrice > trialPriceAmount) {
      labels[0] = i18n.t('cart current plan trial {price} {discountedPrice} {durationQty} {duration}', {
        price: $fc(product.trialPrice),
        discountedPrice: $fc(trialPriceAmount),
        durationQty: durationQtyMatch,
        duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch], durationQtyMatch),
      }) + discount
    } else {
      labels[0] = i18n.tc('{durationQty} {duration} of trial at {trialPrice}', product.trialPrice, {
        durationQty: product.trialDuration,
        duration: i18n.tc(DURATION_LABEL_KEYS[product.trialDurationSpan], product.trialDuration),
        trialPrice: $fc(product.trialPrice)
      }) as String
    }
  } else if (product.startupCost && product.startupCost > 0 && currentPlans.find(el => !el.billingPeriod || el.billingPeriod == "")) {/** nella simplePreviewOrder talvolta il costo di startup non viene riportato */
    /** NO TRIAL - WITH STARTUP*/
    const tantum = currentPlans.find(el => !el.billingPeriod || el.billingPeriod == "")
    const firstSpan = currentPlans.find(el => el.billingPeriod && el.billingPeriod != "") || everlastingPlan
    let durationQtyMatch = firstSpan?.billingPeriod.match(/\d+/g)
    durationQtyMatch = durationQtyMatch ? durationQtyMatch[0] : 1;
    const durationMatch = firstSpan?.billingPeriod.match(/[^\d]+/g)[0] || span
    labels[0] = i18n.t('{durationQty} {duration} at {price} {discountedPrice}', {
      durationQty: durationQtyMatch,
      duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch], durationQtyMatch),
      price: $fc((firstSpan || tantum).amountWithoutPromo + product.startupCost),
      discountedPrice: $fc((firstSpan?.amount || 0) + tantum.amount)
    }) + discount;
    labels[1] = i18n.t('cart {startupCost}', { startupCost: $fc(tantum.amount) })
  } else if (currentPlan) {
    /** NO TRIAL - NO STARTUP */
    if (currentPlan.billingPeriod) {
      let durationQtyMatch = currentPlan.billingPeriod.match(/\d+/g)
      durationQtyMatch = durationQtyMatch ? durationQtyMatch[0] : 1;
      const durationMatch = currentPlan.billingPeriod.match(/[^\d]+/g)[0]
      if (currentPlan.amount < product.prices[span]) { 
        labels[0] = currentPlan.amountWithoutPromo ? i18n.t('{durationQty} {duration} at {price} {discountedPrice}', {
          durationQty: durationQtyMatch,
          duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch], durationQtyMatch),
          price: $fc(product.prices[span]),
          discountedPrice: $fc(currentPlan.amount)
        }) + discount
          : i18n.tc(everlastingPlan ? "cart plan first {price} / {durationQty} {duration}" : "{price} / each {durationQty} {duration}", durationQtyMatch, { price: $fc(currentPlan.amount), durationQty: durationQtyMatch, duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch], durationQtyMatch) })
      } else {
        labels[0] = i18n.tc(`first zuora {price} for {durationQty} {duration}`,durationQtyMatch, {
        price: $fc(currentPlan.amount),
        durationQty: durationQtyMatch,
        duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch], durationQtyMatch),
      })
      }
    } else {
      labels[0] = currentPlan.amountWithoutPromo==currentPlan.amount ? getLabels(i18n, $fc, discountDatas, product, span, variantSku)[0] :`${$fc(currentPlan.amountWithoutPromo)} ${discount}  ${$fc(currentPlan.amount)}`
    }
  }

  /** Not current payment management (middle and everlasting) */
  let index = labels.length;

  const middlePlan = zuoraItemDataPlan.find(el => el.planType == 'Middle')
  if (middlePlan) {
    let durationQtyMatch = middlePlan.billingPeriod.match(/\d+/g)
    durationQtyMatch = durationQtyMatch ? durationQtyMatch[0] : 1;
    let durationMatch = middlePlan.billingPeriod.match(/[^\d]+/g)[0]
    if(durationMatch==DURATION_SPAN_YEARLY_ZUORA) durationMatch = ZUORA_BILLING_SPANS_MAP[DURATION_SPAN_YEARLY_ZUORA]
    const promoPrice = parseFloat(product.promotional[span]?.price || product.prices[span])
    const maxPrice = Math.max(product.prices[span], promoPrice)
    if ( maxPrice > middlePlan.amount) { 
      labels[index] = i18n.t(`${index == 0 ? '' : 'then '}cart middle plan {price} {discountedPrice} {durationQty} {duration}`, {
        price: $fc(maxPrice),
        discountedPrice: $fc(middlePlan.amount),
        durationQty: durationQtyMatch,
        duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch], durationQtyMatch),
      }) + discount
    } else {
      labels[index] = i18n.tc(`zuora {price} for {durationQty} {duration}`,durationQtyMatch, {
        price: $fc(middlePlan.amount),
        durationQty: durationQtyMatch,
        duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch], durationQtyMatch),
      })
    }
    index++;
  }
  if (everlastingPlan) {
    if (middlePlan && everlastingPlan.amount == middlePlan.amount) {
      index--; //replacing middleplan label to avoid label duplicates
    }
    const durationQtyMatch = everlastingPlan.billingPeriod.match(/\d+/g);
    const durationQty = durationQtyMatch ? durationQtyMatch[0] : 1
    const durationMatch = everlastingPlan.billingPeriod.match(/[^\d]+/g)[0]
    // avoid "then" label if this is the only payment instance or the current and everlasting are the same amount and there is no middle amount
    // and remove the current plan label
    index = (!currentPlan || (!middlePlan && everlastingPlan.amount == currentPlan.amount)) ? 0 : index
    const fullPrice = parseFloat(product.discountedPrices[span] ?? product.prices[span])
    if (everlastingPlan.amount < fullPrice) {
      labels[index] = i18n.tc(`zuora ${(index == 0) ? '' : 'then '}{price} {discountedPrice} / {durationQty} {duration}`, durationQty, {
        price: $fc(everlastingPlan.amountWithoutPromo),
        discountedPrice: $fc(everlastingPlan.amount),
        durationQty,
        duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch]),
      }) + discount
    } else {
      labels[index] = i18n.t(`then {price} / {duration}`, {
        price: $fc(everlastingPlan.amount),
        duration: i18n.tc(DURATION_LABEL_KEYS[durationMatch])
      })
    }

  }

  return labels
}

export const getCartItemPaymentFrequency = (cartItem, product) => {
  let paymentFrequency;
  if (product.__typename == BUNDLE_TYPENAME) {
    cartItem.bundle_options.find(el => el.values.find(bo => bo.configurable_options && bo.configurable_options.find(co => {
      if (co.code == 'tipo_abbonamento') {
        paymentFrequency = co.value;
        return co.code == 'tipo_abbonamento'
      } else { return false }
    })))

    if (!paymentFrequency) {
      try {
        paymentFrequency = product.items.filter(el => el.options).map(el => el.options.map(opt => opt.product.tipo_abbonamento)).flat().find(el => !!el);
      } catch (e1) {
        try {
          /** find tipo abbonamento on child options */
          if (cartItem.product.items.find(el => el.tipo_abbonamento)) {
            paymentFrequency = cartItem.product.items.find(el => el.tipo_abbonamento).tipo_abbonamento
          } else {
            paymentFrequency = cartItem.product.items.map(el => el.options.find(o => o.product)).map(el => el.product).flat().map(el => el.variants).flat().map(el => el.product.tipo_abbonamento)[0];
          }
        } catch (e) {
          console.warn('Payment frequency on bundle not found')
        }
      }
    }

  } else if (product.__typename == CONFIGURABLE_TYPENAME) {
    try {
      const tipoAbbonamentoOptions = product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento')
      if (tipoAbbonamentoOptions) {
        const selectedOptionUid = cartItem.configurable_options.find(el => el.configurable_product_option_uid == tipoAbbonamentoOptions.uid).configurable_product_option_value_uid;
        return tipoAbbonamentoOptions.values.find(el => el.uid == selectedOptionUid).value_index
      } else {
        if (product.variants[0].product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO) return product.variants[0].product.tipo_abbonamento;
      }
    } catch (e) {
      console.warn('CartItemUid: ' + cartItem.uid + ', sku: ' + product.sku + 'Configurable without tipo_abbonamento')
    }
  } else if ((product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO || product.tipo_rinnovo == TIPO_RINNOVO_ESPLICITO) && product.tipo_abbonamento) {
    return product.tipo_abbonamento
  }

  return paymentFrequency
}

function canShipItem(item) {
  const includeOfferCodes = ['P0', 'D0', 'CP', 'CE', '0P', '0E'];

  let findShippingElement = false;
  let findEdicolaElement = false;

  if (item.attribute_set_id == '16') {
    findShippingElement = true;
  }

  // Controllo subito se è un configurabile/Elemento da spedire.
  if (item.deliveryType == 'posta') {
    findShippingElement = true;
  }

  // Ha i moduli, quindi è un bundle.
  if (item.moduleList) {
    item.moduleList.map((moduleItem) => {
      if (moduleItem.typeId == 'simple') {
        // Trovato un elemento simple da spedire. Attivare la spedizione.
        findShippingElement = true;
      }
    });
  }

  if (item.deliveryType == 'edicola') {
    findEdicolaElement = true;
  }

  // Se il delivery type è diverso da edicola (noConsegna & posta) e abbiamo trovato un elemento cartaceo si spedisce.
  // Altrimenti, è un tipo edicola! E bisogna andare al form dell'edicola.
  if (!findEdicolaElement && findShippingElement) {
    return { isEdicola: false, isShippable: true, isVirtual: false };
  } else if ((findEdicolaElement && findShippingElement) || (findEdicolaElement && !findShippingElement)) {
    return { isEdicola: true, isShippable: false, isVirtual: false };
  } else {
    return { isEdicola: false, isShippable: false, isVirtual: true };
  }
}

const getPapers = (cartItem, attributeSets) => {
  let deliveryType = ""
  const tipoConsegnaConfigurable = cartItem?.configured_variant?.tipo_consegna
  if (tipoConsegnaConfigurable && tipoConsegnaConfigurable != NO_CONSEGNA_DELIVERY_TYPE) {
    deliveryType = DELIVERY_TYPES_MAP[tipoConsegnaConfigurable]
  } else if (cartItem?.bundle_options) {
    try {
      const deliveryTypeBundle = cartItem.bundle_options.find(el => el.values.find(v => v.configurable_options)).values.find(v => v.configurable_options).configurable_options.find(opt => opt.code == 'tipo_consegna').value
      deliveryType = DELIVERY_TYPES_OPTION_MAP[deliveryTypeBundle] ?? ""
    } catch (er) {
      /*console.log('CATCH:::')
      console.warn(':::Delivery type not found in bundle options, trying in child items')
      const deliveryTypeBundle = cartItem.product.items.find(el => el.options.find(o => o.product.variants)).options.find(el => el.product.variants).product.variants.find(v => v.product.tipo_consegna).product.tipo_consegna
      console.log('deliveryTypeBundle', deliveryTypeBundle)
      console.log('DELIVERY_TYPES_OPTION_MAP[deliveryTypeBundle]', DELIVERY_TYPES_OPTION_MAP[deliveryTypeBundle])
      deliveryType = DELIVERY_TYPES_OPTION_MAP[deliveryTypeBundle] ?? ""*/
    }

  } else if (cartItem.product.tipo_consegna && cartItem.product.tipo_consegna != NO_CONSEGNA_DELIVERY_TYPE) {/** simple */
    deliveryType = DELIVERY_TYPES_MAP[cartItem.product.tipo_consegna] ?? ""
  }

    if (deliveryType !== '') {
      if (attributeSets[cartItem.product.attribute_set_id] == 'periodici') {
        return { distribution: deliveryType }
      } else {
        return {
          distribution: deliveryType,
          quantity: cartItem.quantity,
          /*days: days,
          frequency: frequency,*/ //@TODO con periodici
        }
      }
    }

  const isShippableItem = canShipItem(cartItem);
  if (deliveryType === '' && isShippableItem && isShippableItem.isEdicola && isShippableItem.isShippable) {
    return { distribution: 'Edicola' }
  } else if (deliveryType === '' && isShippableItem && isShippableItem.isShippable) {
    return { distribution: 'Posta' }
  }
  if (cartItem.product.sku.includes('Z.PC')) {
      return { distribution: 'Posta' }
    }
  return null;
}

const getCartItemFromOfferSku = (offer, cartItem) => {
  /**@TODO change separator and fix commented code */
  const splittedSkus = offer.cartItemSku.split('-')
  const offerSku = offer.cartItemSku.split('|')[0];
  const modulesSkus = splittedSkus.slice(1, splittedSkus.length)
  return cartItem.configured_variant && cartItem.configured_variant.sku == offerSku /** configurable */
    || cartItem.bundle_options && cartItem.product.sku == offerSku && cartItem.bundle_options.map(bo => bo.values.map(v => v.sku)).flat().every(el => modulesSkus.includes(el))
    || cartItem.product.sku == offerSku /** others */


}

/**
 * 
 * @param item NON SONO AFFATTO D'ACCORDO SU QUESTO APPROCCIO
 * VA USATO IL CAMPO bundle_name.
 * Vanno sanati i prodotti DLV e PROD e poi @TODO dismettere!
 */
const BUNDLE_NAMES = ['DIGGC', 'DIGLAMC', 'DIGDISO', 'DIGCOCS', 'DIGBASE1S', 'DIGBASECG', 'DIGBASEGD', 'DIGBASERD', 'AECA', 'DIGCOPRO', 'SPRTNP', 'SPRT', 'DIGSITO', 'DIGFISCOPREMIUM', 'DIGFISCOPRO', 'DIGBASESD', 'DIGBASELD', 'DIGBASECD', 'DIGCOPRE', 'DIGLAPRO', 'DIGLAPRE', 'DIGBASE', 'DIGEEPRO', 'DIGEEPRE', 'DIGDIPRO', 'DIGDIPRE', 'DIGPLUS', 'DIGADV', 'DIGFISCOPREMIUM', 'DIGFISCOPRO', 'DIGFISCOSD', 'DIGFISCOFO', 'DIGFISCO1B', 'DIGFISCO', 'DIG24', 'DIGSABME', 'DIGCO', 'DIGDOM', 'DIGDI', 'DIGLA', 'DIGSILVER', 'BUNDLEBD']
const getBundleName = item => {
  return item.product.bundle_name && item.product.bundle_name.trim().length > 0 ? item.product.bundle_name : (
    BUNDLE_NAMES.find(bn => item.product.sku.includes(bn)) ?? ''
  )
}

export const getOffersInfoData = (offerCodeResponse, cart, offersInfo, attributeSets) => {
  let offersInfoData = [];
  /*console.log('offerCodeResponse in hgetOffersInfoData',offerCodeResponse)*/
  offerCodeResponse.forEach((offer, index) => {
    const item = cart.items.find(el => getCartItemFromOfferSku(offer, el))
    if (item) {
      const isSoftware = attributeSets[item.product.attribute_set_id] == 'software'
      if (isSoftware || (item.product.__typename != BUNDLE_TYPENAME && item.product.__typename != BUNDLE_CART_ITEM_TYPENAME)) {
        offersInfoData.push({ code: offer.code, group: item.product.name })
      } else {
        const papers = getPapers(item,attributeSets)
        offersInfoData.push({ code: offer.code, bundleName: getBundleName(item), paper: papers })
      }
    }

  })
  return offersInfoData

}
const composeSimplePreviewOrderBody = async (cart, offerCodeResponse, offersInfo, attributeSets) => {
  let splitFirst = false;

  offerCodeResponse.forEach((offer, index) => {
    const item = cart.items.find(el => el.product.sku == offer.cartItemSku.split('|')[0])
    if (item) {
      // console.log('splitFirst simplePreviewOrder body:', !!item.product.is_trial)
      // console.log('attributeSets[item.product.attribute_set_id]:', attributeSets[item.product.attribute_set_id])
      const isSoftware = attributeSets[item.product.attribute_set_id].toLowerCase() == 'software'
      /*console.log(item)
      console.log('IS_TRIAL:::', !!item.product.is_trial)
      console.log('isSoftware:::', isSoftware)
      console.log('offersInfo[index]:::', offersInfo[index])*/
      if (!!item.product.is_trial || (isSoftware && offersInfo[index].code.split('-')[0].length == 4)) splitFirst = true;
    }

  })
  //console.log('splitFirst simplePreviewOrder body:', splitFirst)
  return {
    offersInfoData: getOffersInfoData(offerCodeResponse, cart, offersInfo, attributeSets),
    splitFirst,
    userId: 'erroreRecuperoDU2',// @TODO recuperare userId (const userId = userID || userIdZuora ? (userID || userIdZuora) : "erroreRecuperoDU2";)
  }
}

export const getCouponKey = item => {
  if (item.configured_variant) {
    return item.configured_variant.sku
  } else if (item.bundle_options) {
    return `${item.product.sku}-${item.bundle_options.map(el => el.values.map(v => v.sku).join('-')).join('-')}`
  } else {
    return item.product.sku
  }
}
/** @TODO why we can't import middlewareconfig and then remove the endpoint from the params
 */
export const composeSimplePreviewOrder = async (req, res, cart, authHeaders, offerCodeResponse, validationDatas, offersInfo, ecGatewayDomain, attributeSets) => {
  let storeCode = DEFAULT_STORE_CODE;
  try {
    storeCode = req.headers.cookie.split(';').find(el => el.includes('24orepro-vsf-store')).split('=')[1]
  } catch (e) { }
  const bodyComposedData = await composeSimplePreviewOrderBody(req.body.cart, offerCodeResponse, offersInfo, attributeSets)


  const body = {
    "accountNumber": "BLANK",
    "orderDate": new Date().toISOString().substring(0, 10),
    "orderType": "CreateSubscription",
    offersInfo: bodyComposedData.offersInfoData,
    splitFirst: bodyComposedData.splitFirst,
    "raw": false,
    "previewPeriods": "24",
    "promo": validationDatas,
    /* customFields: {
       userDu: bodyComposedData.userId,
       ravvedimento: '0',
       ulterioreRavvedimento: '0',
       utmTerm: 'No',
       utmContent: 'No',
       utmMedium: 'No',
       utmName: 'No',
       utmSource: 'No',
     },*/
    /* giftSubscription non gestito qui, ma solo nel checkout*/
  }
  //console.log('SIMPLE PREVIEW ORDER BODY', JSON.stringify(body))
  const { data, status } = await axios.post(`${ecGatewayDomain}/awszuora/simplePreviewOrder`, body, { headers: authHeaders });
  // console.log('::::::.')
  //console.log('SIMPLEPREVIEW ORDER RESPONSE', JSON.stringify(data))
  if (status == 200 && !data.message) {
    /** Getting single planskus (first part of offer code, not product sku) in order to retrieve all billing information grouped for single product and not for plan */
    const planskus = [...new Set(data.previewResult.plan.map(p => p.products.map(product => product.sku)).flat())].filter(sku => sku != 'Promocode')
    // console.log('PLANSKUS', planskus)
    // console.log('OFFERCODE RESPONSE::::::::', offerCodeResponse)
    // console.log('data.previewResult.plan:::::::', data.previewResult.plan)
    if (data.previewResult.plan.length == 0) {
      res.send({ status: 'FAIL', message: 'No plans found in simplePreviewOrder', data })
      return;
    }
    let products = {}
    //const offerCodes = offerCodeResponse.map(el => el.cartItemSku.split('|')[0])
    const discountType = validationDatas.promotionCode.discount.type;
    let percentage, discountAmount;
    discountType == 'percent' ?
      percentage = validationDatas.promotionCode.discount.ratePlan.productRatePlanCharges[0].pricing[0].discountPercentage
      : discountAmount = validationDatas.promotionCode.discount.ratePlan.productRatePlanCharges[0].pricing[0].amount;// @TODO check

    products = {};
    planskus.forEach(zuoraSku => {
      // console.log('zuoraSKU ::: ', zuoraSku)
      const offer = offerCodeResponse.find(el => el.code.split('-')[0].includes(zuoraSku))
      data.previewResult.plan.forEach(plan => {
        const cartItemSku = offer.cartItemSku.split('|')[0]
        products[cartItemSku] = [...(products[cartItemSku] || []), plan.products.filter(product => product.sku == zuoraSku).map(r => {
          return {
            ...r,
            planType: plan.planType,
            billingPeriod: plan.billingPeriod,
            amountWithoutPromo: r.discountedListPrice,
            amount: plan.products.reduce((totaleCorrente, oggetto) => totaleCorrente + oggetto.planPrice, 0),
          }

        })].flat()
        /** Rimuoviamo piani duplicati per presenza di moduli */
        const uniciMap = new Map();
        products[cartItemSku].forEach(oggetto => {
        const planType = oggetto.planType;
        if (!uniciMap.has(planType)) {
          uniciMap.set(planType, oggetto);
        }
      });
      products[cartItemSku] = Array.from(uniciMap.values());
      })
    })
    
    /*console.log('RESULT', JSON.stringify(data.previewResult))*/
    const responseToSend = {
      discountType,
      percentage,
      discountAmount,
      immediatePayment: data.previewResult.nextBillingAmount,/** Comprende le voci di plan con planType Current */
      products,
      /*paymentPlan: data.plan*/
    }
    res.send(responseToSend)
  } else {
    res.send({ status: 'FAIL', message: 'Cannot retrieve simplePreviewOrder', data })

  }
}

export const changeCartCookieDuration = () => {
  let val;
  try {
    val = document.cookie.split(';').find(el => el.includes('24orepro-vsf-cart')).split('=')[1]
  } catch (e) { }
  if (!val) return;
  const data = new Date();
  // Scadenza tra 7 giorni
  data.setTime(data.getTime() + (7 * 24 * 60 * 60 * 1000));
  const exp = "expires=" + data.toUTCString();

  // Riscrivi il cookie con il nuovo valore di scadenza
  document.cookie = "24orepro-vsf-cart=" + val + ";" + exp + ";path=/;domain=.ilsole24ore.com";
}